// Shared icon set for DrawerTabs. Reference an icon by key (`icon: "history"`)
// so every drawer draws the same section with the same glyph.
const svg = (children) => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

export const DRAWER_TAB_ICONS = {
  // Document with lines — main/overview section
  overview: svg(<>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/>
  </>),
  // Circled "i" — info / basic details
  info: svg(<>
    <circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16"/><line x1="12" y1="8" x2="12.01" y2="8"/>
  </>),
  // Form lines with bullets — editable details
  details: svg(<>
    <rect x="3" y="4" width="18" height="16" rx="2"/>
    <line x1="7" y1="9" x2="7.01" y2="9"/><line x1="10" y1="9" x2="17" y2="9"/>
    <line x1="7" y1="13" x2="7.01" y2="13"/><line x1="10" y1="13" x2="17" y2="13"/>
    <line x1="7" y1="17" x2="7.01" y2="17"/><line x1="10" y1="17" x2="14" y2="17"/>
  </>),
  user: svg(<>
    <circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>
  </>),
  users: svg(<>
    <circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/>
    <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14a6.5 6.5 0 0 1 3.5 6"/>
  </>),
  discussions: svg(<>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </>),
  attachments: svg(<>
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
  </>),
  // Clock — time entry
  time: svg(<>
    <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/>
  </>),
  // Bug — defects
  defects: svg(<>
    <rect x="8" y="6" width="8" height="14" rx="4"/>
    <path d="M9 6.5 7.5 4M15 6.5 16.5 4"/>
    <line x1="3" y1="13" x2="8" y2="13"/><line x1="16" y1="13" x2="21" y2="13"/>
    <path d="M4 8.5 8 10M20 8.5 16 10M4 18.5 8 17M20 18.5 16 17"/>
    <line x1="12" y1="11" x2="12" y2="20"/>
  </>),
  // Counter-clockwise clock — history / audit trail
  history: svg(<>
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><polyline points="3 3 3 8 8 8"/>
    <polyline points="12 7 12 12 15 14"/>
  </>),
  // Building — customer
  building: svg(<>
    <rect x="4" y="3" width="16" height="18" rx="1"/>
    <path d="M9 21v-4h6v4"/>
    <line x1="8" y1="7" x2="8.01" y2="7"/><line x1="12" y1="7" x2="12.01" y2="7"/><line x1="16" y1="7" x2="16.01" y2="7"/>
    <line x1="8" y1="11" x2="8.01" y2="11"/><line x1="12" y1="11" x2="12.01" y2="11"/><line x1="16" y1="11" x2="16.01" y2="11"/>
  </>),
  // Folder — projects
  folder: svg(<>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  </>),
  // Box — products
  package: svg(<>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.3 7 12 12 20.7 7"/><line x1="12" y1="22" x2="12" y2="12"/>
  </>),
  // Pulse line — monitoring
  monitoring: svg(<>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </>),
  // Price tag — pricing
  pricing: svg(<>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </>),
  // Crosshair — scope
  scope: svg(<>
    <circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/>
    <line x1="12" y1="1" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="23"/>
    <line x1="1" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="23" y2="12"/>
  </>),
  // Bell — reminders
  reminders: svg(<>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </>),
  // Wallet — spend
  spend: svg(<>
    <path d="M20 7H5a2 2 0 0 1 0-4h13v4"/>
    <path d="M3 5v14a2 2 0 0 0 2 2h15V7"/>
    <circle cx="16" cy="14" r="1.2"/>
  </>),
  // Pencil on note — notes/comments
  notes: svg(<>
    <path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/>
  </>),
  // Key — access
  access: svg(<>
    <circle cx="7.5" cy="15.5" r="4.5"/><path d="M10.7 12.3 21 2M16 7l3 3M18.5 4.5l2 2"/>
  </>),
  // Circle-slash — exclusions
  exclusions: svg(<>
    <circle cx="12" cy="12" r="9"/><line x1="5.6" y1="5.6" x2="18.4" y2="18.4"/>
  </>),
  // Flag — release plan
  release: svg(<>
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/>
  </>),
  // Checked box — checklist
  checklist: svg(<>
    <polyline points="9 11 12 14 22 4"/>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
  </>),
  // Calendar with one highlighted row — weekly
  weekly: svg(<>
    <rect x="3" y="4" width="18" height="17" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <rect x="6" y="13" width="12" height="3" rx="0.5"/>
  </>),
  // Calendar grid — monthly
  monthly: svg(<>
    <rect x="3" y="4" width="18" height="17" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <line x1="8" y1="14" x2="8.01" y2="14"/><line x1="12" y1="14" x2="12.01" y2="14"/><line x1="16" y1="14" x2="16.01" y2="14"/>
    <line x1="8" y1="18" x2="8.01" y2="18"/><line x1="12" y1="18" x2="12.01" y2="18"/><line x1="16" y1="18" x2="16.01" y2="18"/>
  </>),
  // Pie with one quarter cut out — quarterly
  quarterly: svg(<>
    <path d="M21.2 15.9A10 10 0 1 1 8 2.8"/><path d="M22 12A10 10 0 0 0 12 2v10z"/>
  </>),
  // Circular arrows — yearly cycle
  yearly: svg(<>
    <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
    <path d="M3.5 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </>),
};
